import type { BackendRouteDefinition } from '../types';

export const intakeFormRoutes = {
  getPublicIntakeFormDefinition: {
    transport: 'api',
    method: 'GET',
    path: '/public/firms/:firmId/form-definitions/:formId',
    params: (requestData: {
      firmId: string;
      formId: string;
      matterId?: string;
    }) => ({
      firmId: requestData.firmId,
      formId: requestData.formId,
    }),
    query: (requestData: {
      firmId: string;
      formId: string;
      matterId?: string;
    }) => (requestData.matterId ? { matterId: requestData.matterId } : {}),
  },
  submitPublicIntakeFormSubmission: {
    transport: 'api',
    method: 'POST',
    path: '/public/firms/:firmId/form-definitions/:formId/submissions',
    params: (requestData: {
      firmId: string;
      formId: string;
      answers: Record<string, unknown>;
      matterId?: string;
    }) => ({
      firmId: requestData.firmId,
      formId: requestData.formId,
    }),
    body: (requestData: {
      firmId: string;
      formId: string;
      answers: Record<string, unknown>;
      matterId?: string;
    }) => ({
      answers: requestData.answers,
      ...(requestData.matterId ? { matterId: requestData.matterId } : {}),
    }),
  },
} as const satisfies Record<string, BackendRouteDefinition>;
